/*
 * @Author: shiguang
 * @Date: 2023-08-07 16:26:39
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-12-22 14:12:41
 * @Description:
 */
import { createRouter, createWebHistory, NavigationGuardWithThis, RouteRecordRaw } from 'vue-router'
import store, { useCurShop, usePlat, useRtfix, useToken, useUser } from '../store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { wait } from '@/plugins/utils'
import dev from '@/dev'

const routes: Array<RouteRecordRaw> = store.state.route.routes

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  strict: true,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      // return { el: document.querySelector('#app .el-scrollbar__wrap'), top: 0 }
      const el = document.querySelector('#app .el-scrollbar__wrap')
      !to.query.openId && el && el.scroll(0, 0)
    }
  }
})

NProgress.configure({
  easing: 'ease-in-out',
  speed: 800,
  trickleSpeed: 300
})

const useRedirect:NavigationGuardWithThis<void> = async (to, from, next) => {
  // return true
}

router.beforeEach(async (to, from, next) => {
  const w:any = window
  console.log(to, from)
  await dev()
  if (await useRedirect(to, from, next)) return false
  if (w.serverApp) {
    const reloading = w.serverApp.reload('client', to.fullPath)
    if (reloading) {
      console.log('reloading')
      return false
    }
  }
  console.log(useToken())
  console.log(usePlat())
  console.log(useCurShop())
  // if (to.path.includes('login')) {
  //   await wait(30000000)
  // }
  NProgress.start()
  const path = await store.dispatch('route/validator', { to, from })
  await store.dispatch('route/asyncAddUserRoutes')
  next(path)
})

router.afterEach(() => {
  NProgress.done()
})

export default router
